const Range = require('../classes/range')
const intersects = (r1, r2, options) => {
  r1 = new Range(r1, options)
  r2 = new Range(r2, options)
  return r1.intersects(r2, options)
}
module.exports = intersects



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/ranges/intersects.js
// module id = 1931
// module chunks = 1